import axios from "axios";
import type { AxiosError, AxiosInstance, AxiosRequestConfig } from "axios";
import PATH from "./paths";
import authService from "../utils/auth";
import { storage } from "../utils/storage";

interface RespData {
  success: boolean;
  errorCode: number;
  msg?: string;
  data?: any;
  [key: string]: any;
}

async function handleError(error: AxiosError) {
  const response = error?.response;
  if (response?.status === 401) {
    await authService.logout();
    window.location.reload();
  }
}

interface IAxiosInstance {
  get(url: string, config?: AxiosRequestConfig): Promise<Record<string, any>>;
  delete(url: string, config?: AxiosRequestConfig): Promise<Record<string, any>>;
  post(url: string, data?: any, config?: AxiosRequestConfig): Promise<Record<string, any>>;
  put(url: string, data?: any, config?: AxiosRequestConfig): Promise<Record<string, any>>;
}
 
class ConfigureService {
  httpClient: IAxiosInstance & AxiosInstance;

  constructor(url: string, isOauth = false) {
    const options = {
      baseURL: `${isOauth ? process.env.REACT_APP_API_OAUTH_TEST_ENDPOINT : PATH.baseURL}${url}`,
    };

    this.httpClient = axios.create(options);

    this.httpClient.defaults.headers.common["Content-Type"] = "application/json";

    this.httpClient.interceptors.request.use(
      function (config) {
        const token = storage.getTokenFromStorage();
        if (token) {
          config.headers["Authorization"] = token;
        }

        return config;
      },
      function (error) {
        handleError(error);
        return Promise.reject(error);
      }
    );

    this.httpClient.interceptors.response.use(
      async function (res) {
        // const headers = res.config.headers;
        const data: RespData = res.data;

        if (data.errorCode === 401) {
          await authService.logout();
        }

        // return res.data?.data || res;
        return res.data;
      },
      function (error) {
        handleError(error);
        return Promise.reject(error);
      }
    );
  }
}

const enumeratorClient = new ConfigureService(`${PATH.appBaseUrl}${PATH.enumerator.baseUrl}`);
const recruiterClient = new ConfigureService(`${PATH.appBaseUrl}${PATH.recruiter.baseUrl}`);
const appClient = new ConfigureService(PATH.appBaseUrl);
const mediaClient = new ConfigureService(PATH.mediaService.baseURL);

const notificationClient = new ConfigureService(PATH.notificationService.baseURL);

const enumeratorOauthClient = new ConfigureService(
  `${PATH.appBaseUrl}${PATH.enumerator.baseUrl}`,
  true
);

export {
  enumeratorClient,
  appClient,
  recruiterClient,
  enumeratorOauthClient,
  mediaClient,
  notificationClient,
};
